import Cookie from "./Cookies";

export function waitForWindowProperty(windowPropertyName) {
  const cookieParams = {
    name: windowPropertyName,
    expires: "2hours",
  };
  return new Promise((resolve) => {
    const cookieExist = Cookie.get(cookieParams.name);
    if (cookieExist) {
      Cookie.set({ ...cookieParams, value: cookieExist });
      resolve(cookieExist);
    } else if (window[windowPropertyName] !== undefined) {
      Cookie.set({ ...cookieParams, value: window[windowPropertyName] });
      resolve(window[windowPropertyName]);
    } else {
      Object.defineProperty(window, windowPropertyName, {
        set: function (value) {
          if (value !== undefined) {
            Cookie.set({ ...cookieParams, value });
            resolve(value);
          }
          this[`_${windowPropertyName}`] = value;
        },
        get: function () {
          return this[`_${windowPropertyName}`];
        },
        configurable: true,
      });
    }
  });
}

export function waitForVariable(varName, timeout = 5000, interval = 100) {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();

    const check = () => {
      if (typeof window[varName] !== "undefined") {
        resolve(window[varName]);
      } else if (Date.now() - startTime > timeout) {
        // resolve(false);
        reject(new Error(`Timeout waiting for variable: ${varName}`));
      } else {
        setTimeout(check, interval);
      }
    };

    check();
  });
}
